import { Location } from './device';
export const Accuracy = Location.Accuracy;
export const getForegroundPermissionsAsync = Location.getForegroundPermissionsAsync;
export const requestForegroundPermissionsAsync = Location.requestForegroundPermissionsAsync;
export const hasServicesEnabledAsync = Location.hasServicesEnabledAsync;
export const enableNetworkProviderAsync = Location.enableNetworkProviderAsync;
export const getCurrentPositionAsync = Location.getCurrentPositionAsync;
export const reverseGeocodeAsync = Location.reverseGeocodeAsync;
